import React from 'react';

interface SkeletonGridProps {
  count?: number;
}

/** Placeholder product grid shown while products load. Styles live in App.css. */
const SkeletonGrid: React.FC<SkeletonGridProps> = ({ count = 8 }) => (
  <div className="products-grid" aria-hidden="true">
    {Array.from({ length: count }).map((_, i) => (
      <div key={i} className="skeleton-card">
        <div className="sk-img sk-shimmer" />
        <div className="sk-body">
          <div className="sk-line sk-shimmer" />
          <div className="sk-line sk-shimmer" />
          <div className="sk-line short sk-shimmer" />
        </div>
      </div>
    ))}
  </div>
);

export default SkeletonGrid;
